import React, {Component} from "react";
import {connect} from "react-redux";
import {compose} from "recompose";
import {validate} from "../data";
import {calculate} from "../actions";
import {reduxForm, Field} from "redux-form";
import {NextButton} from "../components/buttons";
import {abacus} from "../pages";

const enhance = compose(
  reduxForm({form: 'wizard', destroyOnUnmount: false, forceUnregisterOnUnmount: true, validate}),
  connect(
    (state) => ({ formWizard: state.form.wizard }),
    (dispatch) => ({
      calculate: (payload) => {
        dispatch(calculate(payload))
      }
    })
  )
);

class EmailSubmission extends Component {
  componentDidMount() {
    this.props.calculate(this.props.formWizard.values);
  }

  render() {
    const { formWizard: { syncErrors = {}}, next } = this.props;
    const hasErrors = 'email' in syncErrors;
    const showInvalidEmailError = syncErrors.email === 'invalid-email';
    return (
      <div id="email-submission" className="animated zoomIn">
        <div className="is-hidden-mobile">
          <div className="columns is-centered">
            <div className="column is-12">
              <div className="has-text-centered">
                <div className="header">
                  <div className="header-image has-text-centered">
                    <img className="image" src={abacus} alt=""/>
                  </div>
                  <h1>
                    Crunching the numbers...
                  </h1>
                </div>
                <div className="body">
                  <section>
                    <p>
                      Enter your email for us to send the results to
                    </p>
                  </section>
                  <section>
                    <div className="field has-addons">
                      <div className="control is-expanded">
                        <Field component="input" name="email" type="email" className="input is-medium" onKeyPress={e => {
                          if (e.key === 'Enter' && !hasErrors) { next(); }
                        }}/>
                      </div>
                      <div className="control">
                        <NextButton disabled={hasErrors} text="Submit" {...this.props} />
                      </div>
                    </div>
                    <p className={`help is-danger ${showInvalidEmailError ? 'animated bounceIn' : 'is-invisible'}`}>
                      Please enter a valid email address
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="is-hidden-tablet">
          <div className="columns">
            <div className="column is-10-mobile is-offset-1-mobile">
              <div className="has-text-centered">
                <div className="header">
                  <div className="header-image has-text-centered">
                    <img className="image" src={abacus} alt=""/>
                  </div>
                  <h1>
                    Crunching the numbers...
                  </h1>
                </div>
                <div className="body">
                  <section>
                    <p>
                      Enter your email for us to send the results to
                    </p>
                  </section>
                  <section>
                    <div className="field has-addons">
                      <div className="control is-expanded">
                        <Field component="input" name="email" type="email" className="input is-medium" onKeyPress={e => {
                          if (e.key === 'Enter' && !hasErrors) { next(); }
                        }}/>
                      </div>
                      <div className="control">
                        <NextButton disabled={hasErrors} text="Submit" {...this.props} />
                      </div>
                    </div>
                    <p className={`help is-danger ${showInvalidEmailError ? 'animated bounceIn' : 'is-invisible'}`}>
                      Please enter a valid email address
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(EmailSubmission);




// WEBPACK FOOTER //
// ./src/pages/email-submission.js